// src/pages/sales/ContinentalSalesSummary.jsx
import React from 'react';
import SalesSummary from '../SalesSummary';

const ContinentalSalesSummary = () => {
  return <SalesSummary locationKey="continental" />;
};

export default ContinentalSalesSummary;